import colors from '../constants/Colors';

export default {};

export const getCardColor = (lastTask) => {
  if (lastTask.type === 'break') return colors.ONTRACCR_DARK_YELLOW;
  if (lastTask.startTime && !lastTask.endTime) return colors.ONTRACCR_BLACK;
  return colors.ONTRACCR_OPACITY_GRAY;
};
